module.exports = __webpack_public_path__ + "static/media/game-board-alt.1def9fcb.svg";